<template>
	<div class="app-preview-advanced-list">
		<div
			v-for="item in items"
			:key="`item-${item.key}`"
			class="list-item my-3"
		>

			<slot
				name="item"
				:item="item"
				:key="item.key"
			>
				<slot
					:name="`item--${item.key}`"
					:item="item"
					:key="item.key"
				>
					<div class="d-flex text-textSecondary700">

						<slot
							name="item-title"
							:item="item"
							:key="item.key"
							:title="item.title"
							:appendTitle="appendTitle"
						>
							<div class="list-item-title w-50 ao-p2-regular">

								<slot
									name="item-title-content"
									:item="item"
									:key="item.key"
									:title="item.title"
									:appendTitle="appendTitle"
								>
									{{ item.title }}{{ appendTitle }}
								</slot>

							</div>
						</slot>

						<template v-if="item.valueLoading">
							<div class="d-flex align-center w-100" style="max-width: 80px;">
								<v-progress-linear
									indeterminate
									color="primary"
									height="2"
								/>
							</div>
						</template>
						<template v-else>
							<template v-if="item.values">
								<!-- TODO: добавить слот для переопределения рендера массива values -->
								<div
									class="list-item-values d-flex w-50 ao-p2-medium"
									:class="[
										item.valuesInColumn ? 'flex-column' : '',
									]"
								>
									<span
										v-for="value in item.values"
										:key="`item-${item.key}-value-${value.key}`"
										:class="[
											value.valueClass ?? '',
											value.valueColor ? `text-${value.valueColor}` : 'text-textBody',
										]"
									>
									{{ (value.valueFormatter && typeof value.valueFormatter === 'function') ? value.valueFormatter(value.value) : value.value }}
									</span>
								</div>
							</template>
							<template v-else>
								<slot
									name="item-value"
									:item="item"
									:key="item.key"
									:value="item.value"
									:valueFormatter="item.valueFormatter"
									:valueIfUndefined="valueIfUndefined"
								>
									<slot
										:name="`item--${item.key}--value`"
										:item="item"
										:key="item.key"
										:value="item.value"
										:valueFormatter="item.valueFormatter"
										:valueIfUndefined="valueIfUndefined"
									>
										<div
											class="list-item-value w-50 ao-p2-medium"
											:class="[
												item.valueClass ?? '',
												item.valueColor ? `text-${item.valueColor}` : 'text-textBody',
											]"
										>

											<slot
												name="item-value-content"
												:item="item"
												:key="item.key"
												:value="item.value"
												:valueFormatter="item.valueFormatter"
												:valueIfUndefined="valueIfUndefined"
											>
												<slot
													:name="`item--${item.key}--value-content`"
													:item="item"
													:key="item.key"
													:value="item.value"
													:valueFormatter="item.valueFormatter"
													:valueIfUndefined="valueIfUndefined"
												>
													<template v-if="item.value || item.value === 0">
														{{ (item.valueFormatter && typeof item.valueFormatter === 'function') ? item.valueFormatter(item.value) : item.value }}
													</template>
													<template v-else>
														{{ valueIfUndefined }}
													</template>
												</slot>
											</slot>

											<slot
												name="item-value-popup"
												:item="item"
												:key="item.key"
												:value="item.value"
											>
												<PopupWrapper
													v-if="item?.popupComponent"
													v-model="popupState[item.key]"
												>
													<template v-if="popupState[item.key]">

														<slot
															name="item-value-popup-content"
															:item="item"
															:key="item.key"
															:value="item.value"
															:popupComponent="popupComponent"
															:isActivePopup="popupState[item.key]"
														>
															<component
																:is="item.popupComponent"
																v-bind="item.popupComponentProps ?? {}"
															/>
														</slot>

													</template>
												</PopupWrapper>
											</slot>

										</div>
									</slot>
								</slot>
							</template>

						</template>

					</div>
				</slot>
			</slot>

		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue'

import PopupWrapper from '@/components/ui/popups/PopupWrapper.vue'

const props = defineProps({
	/*
		items: [{
			key: [String, Number], // required
			title: String, // required
			valueLoading: Boolean,

			value: String, // required
			valueFormatter: Function,
			valueClass: String,
			valueColor: String, // textBody - default | success | warning | error
			popupComponent: Component,
			popupComponentProps: {
				entityId: Number,
			},

			// or

			values: [
				{
					key: [String, Number], // required
					value: String, // required
					valueFormatter: Function,
					valueClass: String,
					valueColor: String, // textBody - default | success | warning | error
				},
			],
			valuesInColumn: Boolean,
		}, ...]
	*/
	items: {
		type: Array,
		default: () => ([]),
	},

	appendTitle: {
		type: String,
		default: ':',
	},

	valueIfUndefined: {
		type: String,
		default: '-',
	},
})

const popupState = ref({})

watch(() => (props.items), () => {
	popupState.value = Object.fromEntries(props.items.map((item) => ([item.key, false])))
}, {
	immediate: true,
})
</script>
